var map = {
	"./1.png": 3930,
	"./2.png": 76137,
	"./3.png": 22395,
	"./4.png": 58279,
	"./5.png": 62581,
	"./6.png": 84409,
	"./Avast.png": 41876,
	"./Sail-Away-100x50.jpg": 73088,
	"./Sail-Away.jpg": 74830,
	"./apporoach_man_img.png": 77261,
	"./arrow.png": 9489,
	"./asan.png": 7854,
	"./banner_img.svg": 54521,
	"./blog-1.jpg": 52166,
	"./blog-2.jpg": 77170,
	"./brakets.png": 4371,
	"./bulb.png": 81452,
	"./c++.png": 78943,
	"./circle-2.png": 48907,
	"./contact.svg": 21049,
	"./cool.png": 35126,
	"./creative_bg1-100x50.jpg": 84386,
	"./creative_bg1.jpg": 55389,
	"./css_1.png": 66406,
	"./css_2.png": 70530,
	"./cup.png": 97917,
	"./design.png": 77613,
	"./developer-img/10.png": 1091,
	"./developer-img/1009269.jpg": 95963,
	"./developer-img/1302261.jpg": 526,
	"./developer-img/1323866.jpg": 80764,
	"./developer-img/angular.png": 33392,
	"./developer-img/code.png": 93414,
	"./developer-img/design-logo1.png": 21212,
	"./developer-img/design-logo2.png": 34286,
	"./developer-img/design-logo3.png": 23885,
	"./developer-img/design-logo4.png": 9676,
	"./developer-img/design-logo5.png": 46883,
	"./developer-img/dot.png": 51692,
	"./developer-img/dot_big.png": 46001,
	"./developer-img/html.png": 52447,
	"./developer-img/logo1.png": 36379,
	"./developer-img/logo2.png": 1011,
	"./developer-img/man.png": 51740,
	"./developer-img/mern.png": 46657,
	"./developer-img/polygon.png": 85727,
	"./developer-img/pr1.jpg": 14767,
	"./developer-img/pr2.jpg": 90348,
	"./developer-img/pr3.jpg": 17249,
	"./developer-img/react.png": 84092,
	"./developer-img/shap.png": 92,
	"./developer-img/testimonial_bg_circle.png": 64831,
	"./developer-img/video_shap.png": 42805,
	"./dot.png": 68442,
	"./f_man.png": 53987,
	"./grid-70.png": 44485,
	"./h_pijom1.png": 40175,
	"./icebg-100x50.jpg": 46550,
	"./icebg.jpg": 71811,
	"./icon.jpeg": 57789,
	"./img-1.png": 29822,
	"./img-3.png": 66996,
	"./img-4.png": 25813,
	"./img-5.png": 48206,
	"./img-6.png": 21408,
	"./img-8.png": 49874,
	"./img.svg": 25599,
	"./intro-bg.jpg": 56328,
	"./logo-blue.png": 17822,
	"./logo.png": 46105,
	"./logo2.png": 27997,
	"./man.jpg": 52643,
	"./mobile.svg": 80756,
	"./new-page/arrow.png": 3927,
	"./new-page/bottomshape.png": 50583,
	"./new-page/dot.png": 78498,
	"./new-page/line1.png": 65263,
	"./new-page/line2.png": 29217,
	"./new-page/line3.png": 98537,
	"./new-page/line4.png": 20224,
	"./new-page/shape1.png": 73652,
	"./new-page/shape2.png": 60003,
	"./new-page/shape3.png": 77444,
	"./new-page/slider_img1.jpg": 3949,
	"./new-page/slider_img2.jpg": 10754,
	"./new-page/slider_img3.jpg": 35658,
	"./new-page/slider_img4.jpg": 22847,
	"./new-page/topshape.png": 68471,
	"./new-page/topshape2.png": 51930,
	"./new1.jpg": 21247,
	"./our-coaches-2.jpg": 90889,
	"./our-coaches-7.jpg": 12087,
	"./php.png": 83305,
	"./pijom_2.png": 94924,
	"./play1.png": 23768,
	"./play2.png": 75585,
	"./portfolio/1.jpg": 31086,
	"./portfolio/10.jpg": 64512,
	"./portfolio/2.jpg": 97097,
	"./portfolio/3.jpg": 10112,
	"./portfolio/4.jpg": 25564,
	"./portfolio/9.jpg": 43912,
	"./portfolio/img-3.jpg": 27713,
	"./portfolio1.jpg": 92074,
	"./portfolio2.jpg": 23725,
	"./post-img1.jpg": 49997,
	"./post-img2.jpg": 15437,
	"./post-img3.jpg": 66515,
	"./profile.jpg": 63560,
	"./search.png": 92985,
	"./service.svg": 6273,
	"./shadow.png": 42504,
	"./shap1.png": 85909,
	"./shape.png": 17127,
	"./sitting.png": 81307,
	"./slack.png": 78666,
	"./slider1.png": 50372,
	"./slider2.png": 10596,
	"./strategy.png": 93263,
	"./table.png": 46622,
	"./testimonial.svg": 51560,
	"./torrent.png": 90027,
	"./tr_three.png": 8426,
	"./tr_two.png": 51231,
	"./triangle.png": 39609,
	"./twitter.png": 81966,
	"./wave.png": 66467,
	"./web-design.png": 52348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74339;